import { Button, Input, message, Modal, Space, Spin, Table, Typography } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { contractDataHandle } from '../state/actions';
import axios from 'axios';
import { Loading } from '../../Common';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from "@ant-design/icons";
import { formatPhoneNumber } from '../../Common/utils/universalFuntions';
import { setSelectedCompanyDataOfSOW } from '../features/helperFunctions';
import { contractStoreHandle } from '../../ContractStore/state/actions';
import { useMediaQuery } from 'react-responsive';
const { confirm } = Modal;

const { Text } = Typography;

function SowCompanySelectionModal({ setModalState, contractAuthKey, rootDocData, currentUrlId, handleInputSave }) {
    const { sowCoDataError, sowCoDataLoading, soaCoRecords } = useSelector((state) => state.createOffer);
    const [disableBtn, setDisableBtn] = useState(true);
    const searchRef = useRef(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(20);
    const isSmallScreen = useMediaQuery({maxWidth: 550});
    const isMediumScreen = useMediaQuery({minWidth: 551, maxWidth: 850});
    const [searchObj, setSearchObj] = useState({
        searchType: '',
        searchText: '',
    });
    const searchInputRef = useRef(null);

    const dispatch = useDispatch();

    useEffect(() => {
        let unmounted = {
            value: false,
        };
        let sourceAxios = axios.CancelToken.source();
        dispatch(contractDataHandle.getSowCoData({
            unmounted,
            sourceAxios,
            contractAuthKey,
            pageNumber: currentPage,
            limit,
            searchObj,
        }));

        return () => {
            unmounted.value = true;
            sourceAxios.cancel("Cancelling in cleanup");
        };

    }, [currentPage, searchObj, limit]);

    const handleReset = (clearFilters, setSelectedKeys, dataIndex) => {

        searchRef.current = true;
        let queryData = { ...searchObj };

        if (dataIndex === 'companyName') {
            delete queryData.companyName;
        } else if (dataIndex === 'address') {
            delete queryData.address;
        }

        clearFilters();
        setSelectedKeys("");
        setSearchObj({ type: '', searchText: '' });
        setCurrentPage(1);
        searchRef.current = false;
    };

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        searchRef.current = true;
        setSearchObj({ searchType: dataIndex, searchText: selectedKeys[0] });
        setCurrentPage(1);
        searchRef.current = false;
    };

    let getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
        }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Search ${(dataIndex === 'companyName') ? 'Company Name' : (dataIndex === 'address') ? 'Full Address' : ''}`}
                    ref={searchInputRef}
                    value={selectedKeys[0]}
                    onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                    }}
                    onPressEnter={() => {
                        searchRef.current = true;
                        handleSearch(selectedKeys, confirm, dataIndex);
                        setDisableBtn(false);
                    }}
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => {
                            searchRef.current = true;
                            handleSearch(selectedKeys, confirm, dataIndex);
                            setDisableBtn(false);
                        }}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => {
                            handleReset(clearFilters, setSelectedKeys, dataIndex);
                            setDisableBtn(true);
                        }}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined, fontSize: '16px' }} />
        ),
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => {
                    if (searchInputRef.current) {
                        searchInputRef.current.focus({ cursor: "end" });
                    }
                }, 10);
            }
        },
        render: (text) =>
            searchObj.searchType === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                    searchWords={[searchObj.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ""}
                />
            ) : (
                text
            ),
    });

    const fetchSowCoData = (pageNumber = 1, newPageSize = limit) => {
        setCurrentPage(pageNumber);
        setLimit(newPageSize)
    };

    const handleRowClick = (record) => {
        createSpdOrSwaConfirmationModal();
        setSelectedCompanyDataOfSOW({ selectedData: record, rootDocData, currentUrlId, handleInputSave })
        setModalState((prevState) => ({ ...prevState, SOWSelectCompanyModal: false }))
    };

    const createSpdOrSwaConfirmationModal = () => {
        confirm({
            title: `Would you want to generate a ${rootDocData?.contractType === 'SWA' ? "Seller's Property Disclosure (Residential)" : rootDocData?.contractType === 'SPD' ? "Source of Water Addendum" : "" } form with the selected Source of Water Company?`,
            content: "",
            okText: "Yes",
            cancelText: "No",
            onOk() {
                dispatch(contractStoreHandle.autoSaveContract({currentUrlId, contractAuthKey, createAdditionalDoc: true}));
            },
            onCancel() { },
        })
    }

    return (
        <div>
            <Modal
                visible={true}
                title={<div className='commonModalTitle'>Select Water Source Company</div>}
                footer={false}
                closable={true}
                onCancel={() => setModalState((prevState) => ({ ...prevState, SOWSelectCompanyModal: false }))}
                width={800}
            >
                <div>
                    {sowCoDataLoading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30vh' }}><Spin size='large' /></div>
                    ) : sowCoDataError ? (
                        message.error(sowCoDataError)
                    ) : (
                        <Table
                            size={(isMediumScreen || isSmallScreen) ? 'small' : 'large'}
                            dataSource={soaCoRecords?.sowCoData?.length > 0 ? soaCoRecords.sowCoData.map((item, index) => ({
                                ...item,
                                key: index,
                            })) : []}
                            columns={[
                                {
                                    title: "Company Name",
                                    dataIndex: "companyName",
                                    key: "companyName",
                                    // ellipsis: true,
                                    sorter: (a, b) => a.companyName.localeCompare(b.companyName),
                                    ...getColumnSearchProps("companyName"),
                                    onCell: (record) => ({
                                        onClick: () => handleRowClick(record),
                                        style: { cursor: "pointer" },
                                    }),
                                },
                                {
                                    title: "Address",
                                    dataIndex: "address",
                                    key: "address",
                                    // ellipsis: true,
                                    ...getColumnSearchProps("address"),
                                    onCell: (record) => ({
                                        onClick: () => handleRowClick(record),
                                        style: { cursor: "pointer" },
                                    }),
                                },
                                {
                                    title: "Phone",
                                    dataIndex: "phone",
                                    key: "phone",
                                    width: 150,
                                    render: (text) => (
                                        <a href={`tel:${text}`} style={{ color: "#178DFA" }}>
                                            {text && formatPhoneNumber(text)}
                                        </a>
                                    ),
                                },
                                {
                                    title: "Website",
                                    dataIndex: "website",
                                    key: "website",
                                    render: (text) =>
                                        text ? (
                                            <a
                                                href={text.startsWith("http") ? text : `https://${text}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <Text copyable style={{ color: "blue" }}>{text}</Text>
                                            </a>
                                        ) : (
                                            "N/A"
                                        ),
                                },
                            ]}
                            pagination={{
                                position: ["bottomCenter"],
                                current: currentPage,
                                pageSize: limit,
                                total: soaCoRecords?.totalRecords || 0,
                                showSizeChanger: true,
                                onChange: (page, pageSize) => fetchSowCoData(page, pageSize),
                                onShowSizeChange: (current, size) => fetchSowCoData(1, size),
                            }}
                            loading={sowCoDataLoading}
                            bordered
                            scroll={{ x: 500, y: 400 }}
                            locale={{
                                emptyText: "No matching records found. Please refine your search.",
                            }}
                        />
                    )}
                </div>
            </Modal>
        </div>
    )
}

export default SowCompanySelectionModal